/* eslint-disable */
export const environment: any = {
  useBff: false,
  production: false,
  mock: false,
  apiUrl: 'https://mkt-pme-hom.usto.re/api/v1',
  externalGateServiceUrl: 'https://mkt-pme-hom.usto.re/external-gate-service/v1',
  apiKey: 'MKT-SYEV1DLV-_qCqx7odbPUuQ',
  apiKeyExternalGate: 'EXTERNAL_GATE_SERVICE',
  appName: 'UMarket PME',
  defaultLanguage: 'pt-BR',
  supportedLanguages: ['pt-BR', 'en-US', 'es-ES'],
  version: '1.0.0-dev',
  debug: true,
  logLevel: 'debug',
  basePath: '/empresas/hubdesolucoes',
  gtm: {
    containerId: 'GTM-PPLS582R'
  },
  claroFixaAuthUrl: 'https://hml-auth.claro.com.br/authorize?client_id=INT_ECOM_PME_FIXA&response_type=code&scope=openid+net_basic&nonce=abc123&redirect_uri=https://mkt-pme-hom.usto.re',
  mceRedirectUrl: 'https://caregiver-audacity-liftoff.ngrok-free.dev',
  partnerHubOboticarioUrl: 'https://oboticario.usto.re/',
  chatBotUrl: 'https://marketplace-webhook-web.hmg.ghitss.net/'
};